export default function AdminEventsIdPage() {
	return <div></div>;
}
